export default __webpack_public_path__ + "assets/sounds/8cb24a24fbba36ccc596b0a372404b83.mp3";